import React from 'react';
import { NavLink } from 'react-router-dom';
import { Wrench, Phone, Mail, MapPin, } from 'lucide-react';
import { FaInstagram, FaFacebook, FaTwitter } from "react-icons/fa";
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">
          {/* Brand */}
          <div className="footer__brand">
            <div className="footer__logo">
              <div className="footer__logo-icon"><Wrench size={16} /></div>
              <span className="footer__logo-name">AutoElite</span>
            </div>
            <p className="footer__tagline">
              Where precision meets luxury. Your vehicle deserves nothing less than perfection.
            </p>
            <div className="footer__social">
              <a href="https://instagram.com/autoelite" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram size={18} /></a>
              <a href="https://facebook.com/autoelite" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebook size={18} /></a>
              <a href="https://twitter.com/autoelite" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter size={18} /></a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer__col">
            <h4 className="footer__col-title">Quick Links</h4>
            <ul className="footer__links">
              {[
                ['/', 'Home'],
                ['/services', 'Services'],
                ['/booking', 'Book a Service'],
                ['/records', 'My Records'],
                ['/about', 'About Us'],
              ].map(([path, label]) => (
                <li key={path}><NavLink to={path}>{label}</NavLink></li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="footer__col">
            <h4 className="footer__col-title">Services</h4>
            <ul className="footer__links">
              {['Engine Service', 'Full Detailing', 'Premium Wash', 'Brake Repair', 'AC Service', 'Tyre & Wheel'].map(s => (
                <li key={s}><a href="/services">{s}</a></li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="footer__col">
            <h4 className="footer__col-title">Contact Us</h4>
            <ul className="footer__contact">
              <li><Phone size={14} /><span>+91 77194 12034</span></li>
              <li><Mail size={14} /><span>gurkiratadmin@autoelite.in</span></li>
              <li><MapPin size={14} /><span>#24, Kissan Market, Sirhind Road, Patiala, Punjab, 147001</span></li>
            </ul>
            <div className="footer__hours">
              <p><strong>Mon–Sat:</strong> 8:00 AM – 8:00 PM</p>
              <p><strong>Sunday:</strong> 10:00 AM – 4:00 PM</p>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p>© {new Date().getFullYear()} AutoElite. All rights reserved.</p>
          <div className="footer__bottom-links">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}